import { faFlask, faChartBar, faUndo, faCog, faHome, faPalette, faQuestion, faUser, faUserHeadset, IconDefinition, faMegaphone, faFileChartLine, faComments } from "@fortawesome/pro-solid-svg-icons";
import { PermissionEnums } from "@yodlee/common-components/dist/types/enumerations";
import { Permission } from "../types/interfaces/permission";
import * as LabelConfigs from "./label";
import * as UrlConfigs from "./url";

interface MenuItem {
    key: string,
    url: string,
    name: string,
    icon?: IconDefinition
    subMenus?: Array<MenuItem>
}

export const SIDEBAR_MENU = (permissions: Array<Permission>, isAdminOrSuperAdmin: boolean = true, isYodlee?: boolean, isLegacyViewEnabled: boolean = true, isSupportUser: boolean = false, userFeatures: Array<any> = [], brandproducts: any = {}): { TOP: Array<MenuItem>, BOTTOM: Array<MenuItem> } => ({
    TOP: [
        {
            key: "dashboard",
            url: UrlConfigs.ROUTES.DASHBOARD.url,
            name: LabelConfigs.DASHBOARD,
            icon: faHome
        },
        {
            key: "support",
            url: UrlConfigs.ROUTES.SUPPORT.url,
            name: LabelConfigs.SUPPORT,
            icon: faUserHeadset,
            subMenus: [
                ...permissions.find(permission => permission.id === PermissionEnums.SERVICE_REQUESTS.ROOT) ? [{
                    key: "service-requests",
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SERVICE_REQUESTS.url,
                    name: LabelConfigs.SERVICE_REQUESTS
                }] : [],
                ...permissions.find(permission => permission.id === PermissionEnums.CUSTOMERS.ROOT) ? [{
                    key: "customers",
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.CUSTOMERS.url,
                    name: LabelConfigs.CUSTOMERS
                }] : [],
                {
                    key: "sites",
                    url: UrlConfigs.ROUTES.SUPPORT.subRoutes.SITES.url,
                    name: LabelConfigs.SITES
                },
                {
                    key: "status",
                    url: UrlConfigs.ROUTES.STATUS.url,
                    name: LabelConfigs.STATUS
                }
            ]
        },
        //we will enable it when analytics API gets integrated
        ...(permissions.find(permission => permission.id === PermissionEnums.ANALYTICS.ROOT)) ? [{
            key: "analytics",
            url: UrlConfigs.ROUTES.ANALYTICS.url,
            name: "Analytics",
            icon: faChartBar
        }] : [],
        ...((userFeatures.find(feat => feat.id === 5) && (brandproducts?.isVerificationEnabled || brandproducts?.isAggregationEnabled)) || userFeatures.find(feat => feat.id === 8)) ? [{
            key: "product-health-reporting",
            url: UrlConfigs.ROUTES.MANAGEMENT_REPORTING.url,
            name: LabelConfigs.MANAGEMENT_REPORTING,
            icon: faFileChartLine,
            subMenus: [
                ...userFeatures.find(feat => feat.id === 8) ? [{
                    key: "fastlink-journey-analytics",
                    url: UrlConfigs.ROUTES.MANAGEMENT_REPORTING.subRoutes.FASTLINK_JOURNEY_ANALYTICS.url,
                    name: LabelConfigs.FASTLINK_JOURNEY_ANALYTICS
                }] : [],
                ...brandproducts?.isVerificationEnabled ? [{
                     key: "aggregation",
                    url: UrlConfigs.ROUTES.MANAGEMENT_REPORTING.subRoutes.AGGREGATION.url,
                    name: LabelConfigs.AGGREGATION
                }] : [],
                ...brandproducts?.isAggregationEnabled ? [{
                    key: "verification",
                    url: UrlConfigs.ROUTES.MANAGEMENT_REPORTING.subRoutes.VERIFICATION.url,
                    name: LabelConfigs.VERIFICATION
                }] : []
            ]
        }] : [],
        ...(permissions.find(permission => permission.id === PermissionEnums.PRODUCT_AND_MARKETING_INSIGHTS.ROOT)) ? [{
            key: "ieb",
            url: UrlConfigs.ROUTES.IEB.url,
            name: "Product & Marketing Insights",
            icon: faMegaphone,
            subMenus: [
                    ...(permissions.find(permission => permission.id === PermissionEnums.PRODUCT_AND_MARKETING_INSIGHTS.SEGMENTATION)) ? [{
                        key: "segmentation",
                        url: UrlConfigs.ROUTES.IEB.subRoutes.SEGMENTATION.url,
                        name: "Segmentation"
                    }] : [],
                    ...(permissions.find(permission => permission.id === PermissionEnums.PRODUCT_AND_MARKETING_INSIGHTS.PRODUCT_INSIGHTS)) ? [ {
                        key: "productinsights",
                        url: UrlConfigs.ROUTES.IEB.subRoutes.PRODUCT_INSIGHTS.url,
                        name: "Product Insights"
                    }] : [],
                    ...(permissions.find(permission => permission.id === PermissionEnums.PRODUCT_AND_MARKETING_INSIGHTS.INSIGHTS_DASHBOARD)) ? [ {
                        key: "insightsdashboards",
                        url: UrlConfigs.ROUTES.IEB.subRoutes.INSIGHTS_DASHBOARD.url,
                        name: "Insights Dashboards"
                    }] : []
                ]
        }] : [],
        ...(permissions.find(permission => permission.id === PermissionEnums.PRODUCTS.ROOT)) ? [{
            key: "products",
            url: UrlConfigs.ROUTES.PRODUCTS.url,
            name: "Products",
            icon: faPalette
        }] : [],
        ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.ROOT)) ? [{
            key: "trails",
            url: UrlConfigs.ROUTES.TRIALS.url,
            name: "TRIALS",
            icon: faFlask,
            subMenus: [
                ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.CREDIT_ACCELARATOR)) ? [{
                    key: "creditmatrix",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.CREDIT_ACCELARATOR.url,
                    name: "Credit Matrix"
                }] : [],
                ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.CONSUMER_INSIGHTS)) ? [ {
                    key: "consumerInsigts",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.CONSUMER_INSIGHTS.url,
                    name: "Consumer Insights"
                }] : [],
                  ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.VERIFICATION)) ? [ {
                    key: "verification",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.VERIFICATION.url,
                    name: "Verification"
                }] : [],
                 ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.PFM)) ? [ {
                    key: "pfm",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.PFM.url,
                    name: "PFM"
                }] : [],
                ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.SMB)) ? [ {
                    key: "smb",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.SMB.url,
                    name: LabelConfigs.SMB
                }] : [],
                ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.ATV)) ? [ {
                    key: "atv",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.ATV.url,
                    name: LabelConfigs.ATV
                }] : [],
                ...(permissions.find(permission => permission.id === PermissionEnums.TRIALS.ADVISOR_INSIGHTS)) ? [ {
                    key: "advisorInsights",
                    url: UrlConfigs.ROUTES.TRIALS.subRoutes.ADVISOR_INSIGHTS.url,
                    name: "Advisor Insights"
                }] : []
                ]
        }] : [],
        ...isLegacyViewEnabled && !isSupportUser ? [{
            key: "classic",
            url: UrlConfigs.ROUTES.LEGACY_EXPERIENCE.url,
            name: "Classic",
            icon: faUndo
        }] : [],
        ...(permissions.find(permission => permission.id === PermissionEnums.USER_MANAGEMENT.ROOT) || isAdminOrSuperAdmin || isYodlee) && !isSupportUser ? [{
            key: "settings",
            url: UrlConfigs.ROUTES.SETTINGS.url,
            name: "Settings",
            icon: faCog,
            subMenus: [
                ...permissions.find(permission => permission.id === PermissionEnums.USER_MANAGEMENT.ROOT) ? [{
                    key: "permission",
                    url: UrlConfigs.ROUTES.SETTINGS.subRoutes.PERMISSIONS.url,
                    name: "Permissions"
                }] : [],
                ...(isYodlee
                    && permissions.find(permission => permission.id === PermissionEnums.USER_MANAGEMENT.ROOT)) ? [{
                    key: "insights-user",
                    url: UrlConfigs.ROUTES.SETTINGS.subRoutes.MANAGE_INSIGHTS_USER.url,
                    name: "Manage Insights User"
                }] : [],
                ...isAdminOrSuperAdmin ? [{
                    key: "system-settings",
                    url: UrlConfigs.ROUTES.SETTINGS.subRoutes.SYSTEM_SETTINGS.url,
                    name: "System settings"
                }] : []
            ]
        }] : [],
        ...isYodlee && !isSupportUser ? [{
            key: "internal-tools",
            url: UrlConfigs.ROUTES.INTERNAL_TOOLS.url,
            name: "Internal Tools",
            subMenus: [
                ...permissions.find(permission => permission.id === PermissionEnums.OPEN_BANKING.ROOT) ? [{
                    key: "yodlee-customers",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.YODLEE_CUSTOMERS.url,
                    name: "Yodlee Customers"
                }] : [],
                {
                    key: "onboarding",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.ONBOARDING.url,
                    name: "Onboarding"
                },
                ...permissions.find(permission => permission.id === PermissionEnums.NOTIFICATIONS.ROOT) ? [{
                    key: "notifications",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.NOTIFICATIONS.url,
                    name: "Notifications"
                }] : [],
                ...permissions.find(permission => permission.id === PermissionEnums.INTERNAL_TOOLS.MERCHANT_METADATA) ? [{
                    key: "merchant-metadata",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.MERCHANT_METADATA.url,
                    name: "Merchant Metadata"
                }] : [],
                ...permissions.find(permission => permission.id === PermissionEnums.INTERNAL_TOOLS.SITE_METADATA) ? [{
                    key: "site-metadata",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.SITE_METADATA.url,
                    name: "Site Metadata"
                }] : [],
                ...permissions.find(permission => permission.id === PermissionEnums.INTERNAL_TOOLS.ASK_YODLEE_ADMIN_PORTAL && (permission.type === 1 || permission.type === 2)) ? [{
                    key: "ask-yodlee-admin-portal",
                    url: UrlConfigs.ROUTES.INTERNAL_TOOLS.subRoutes.ASK_YODLEE_ADMIN_PORTAL.url,
                    name: "Ask Yodlee Admin Portal"
                }] : []
            ]
        }] : [],
    ],
    BOTTOM: [
        // {
        //     key: "splash-screen",
        //     name: LabelConfigs.SPLASH,
        //     url: UrlConfigs.ROUTES.SPLASH.url,
        //     icon: faPlay
        // },
        {
            key: "questions",
            name: LabelConfigs.Questions,
            url: UrlConfigs.ROUTES.QUESTIONS.url,
            icon: faQuestion
        },
        {
            key: "my-account",
            url: UrlConfigs.ROUTES.MY_ACCOUNT.url,
            name: "My account",
            icon: faUser,
            subMenus: [
                {
                    key: "profile",
                    url: UrlConfigs.ROUTES.MY_ACCOUNT.url,
                    name: LabelConfigs.PROFILE
                },
                {
                    key: "sign-out",
                    url: UrlConfigs.ROUTES.MY_ACCOUNT.subRoutes.SIGN_OUT.url,
                    name: LabelConfigs.SIGN_OUT
                }
            ]
        }
    ]
})
